<div class="absolute inset-0">
  <div class="relative container m-auto flex flex-col h-full justify-between ">

    <app-navbar [showBrand]="false"></app-navbar>

    <div class="flex flex-col justify-center items-center">
      <h2 class="text-slate-300">Get your <span class="text-white">GameFace</span> on!</h2>

      <mat-form-field class="example-full-width">
        <mat-label>Enter room code</mat-label>
        <input matInput type="text" [formControl]="roomCodeControl" name="roomCode" required/>
        <button mat-button matSuffix class='mx-3' (click)="checkCode()" [attr.aria-label]="'Join Room'">
          Join Room
        </button>
        <mat-error *ngIf="roomCodeControl.hasError('noRoom')">No room found</mat-error>
        <mat-error *ngIf="roomCodeControl.hasError('inactiveRoom')">Room is no longer active</mat-error>
      </mat-form-field>
    </div>

    <div>
      <app-menu-bar *ngIf="user"></app-menu-bar>
    </div>

  </div>
  <app-footer></app-footer>
</div>



